import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Button, Container, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../context/auth';
import { Helmet } from 'react-helmet-async';

const Register = () => {  
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [orgName, setOrgName] = useState("")
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);  // New loading state
  const [requireRestore, setRequireRestore] = useState(false)
  const [restoreAccount, setRestoreAccount] = useState(false); // State to track if restore confirmation is needed

  // Hook
  const navigate = useNavigate();
  const {registerUser} = useAuth()

  const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		
		// Check if passwords match
		if (password !== confirmPassword) {
			setError('Passwords do not match');
			return;
		}
		setIsLoading(true);  // Start loading

		try {
			await registerUser({
				firstName, 
				lastName, 
				email, 
				password, 
				orgName,
        restoreAccount
			});  // Call register function from AuthContext
			
			// Redirect to dashboard on successful registration
			navigate('/dashboard');
		} catch (err: any) {
      // console.log(err.response?.data.name);
      if(err?.response?.data?.name === "RestoreConfirmationRequired") {
        setRequireRestore(true);
        setError("An account with this email was previously deleted and scheduled for permanent deletion. Confirm you want to restore it. We'll update the account with the provided details.");
      } else {
			  setError('Registration failed. Please try again.');
      }
		} finally {
			setIsLoading(false);  // Stop loading
		}
  };

  return (
    <Container className="mt-5"  style={{ maxWidth: '500px' }}>
      <Helmet>
        <title>Register - QuickyChat</title>
        <meta name="description" content="Register for a new account on QuickyChat to start chatting with your friends and colleagues." />
        <meta name="keywords" content="QuickyChat, Register, Chat, Messaging, Sign Up" />
      </Helmet>
      <h2 className="mb-4 text-center">Register</h2>
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formName" className="mb-3">
          <Form.Label>First Name*</Form.Label>
          <Form.Control
            type="text"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
        </Form.Group>

		<Form.Group controlId="formName" className="mb-3">
          <Form.Label>Last Name*</Form.Label>
          <Form.Control
            type="text"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group controlId="formEmail" className="mb-3">
          <Form.Label>Email address*</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Form.Group>

		<Form.Group controlId="formName" className="mb-3">
          <Form.Label>Organization</Form.Label>
          <Form.Control
            type="text"
            placeholder="Organization Name"
            value={orgName}
            onChange={(e) => setOrgName(e.target.value)}
          />
        </Form.Group>

        <Form.Group controlId="formPassword" className="mb-3">
          <Form.Label>Password*</Form.Label>
          <Form.Control
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group controlId="formConfirmPassword" className="mb-3">
          <Form.Label>Confirm Password*</Form.Label>
          <Form.Control
            type="password"
            placeholder="Confirm your password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </Form.Group>

        {error && !requireRestore && (
          <Alert variant="danger" className="mt-3">
            {error}
          </Alert>
        )}
        {requireRestore && (
          <Alert variant="warning" className="mt-3">
            <p>{error}</p>
            <Form.Check
              type="checkbox"
              label="Confirm restore of deleted account"
              checked={restoreAccount}
              onChange={(e) => setRestoreAccount(e.target.checked)}
            />
          </Alert>
        )}

        <Button variant="primary" type="submit" className="w-100">
			{isLoading ? <Spinner animation="border" size="sm" /> : 'Register'}
        </Button>
      </Form>
	  <p className="text-center mt-3">
		Already have an account? <Link to="/login" className='text-white'><strong>Login here</strong></Link>
	</p>
    </Container>
  );
};

export default Register;
